// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDTRL2BATqAN2t4bLIxZvviei-ckLpZosc",
  authDomain: "miotloch-dev.firebaseapp.com",
  projectId: "miotloch-dev",
  storageBucket: "miotloch-dev.firebasestorage.app",
  messagingSenderId: "992856535538",
  appId: "1:992856535538:web:a30e392a738c7039b03b6b"
};

export default firebaseConfig;